import { render, staticRenderFns } from "./pubNews.vue?vue&type=template&id=30cb8972&scoped=true"
import script from "./pubNews.vue?vue&type=script&lang=js"
export * from "./pubNews.vue?vue&type=script&lang=js"
import style0 from "./pubNews.vue?vue&type=style&index=0&id=30cb8972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb8972",
  null
  
)

export default component.exports